var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{on:{"click":function($event){return _vm.sendMessage('Hi')}}},[_vm._v("Message")])
}
var staticRenderFns = []

export { render, staticRenderFns }